import glamorous from 'glamorous';

const Caption = glamorous.p({
  margin: 0,
});

export { Caption };



// WEBPACK FOOTER //
// ./src/components/JobDescription/styles.js